import { LotJobStatusEnumId } from '@classictechsolutions/hubapi-transpiled-enums/build/main/lib/enums/LotJobStatusEnum';
import { ILotMappedItem } from '@app/logic/lots';
import { ILotDto } from '@classictechsolutions/hubapi-transpiled-enums';

export function isCostActionDisabled(): boolean {
    return this.lotDto && this.lotDto.jobStatus === LotJobStatusEnumId.Cancelled;
}

export function isCostActionDisabledForLot(lot: ILotMappedItem): boolean {
    return lot.jobStatus === LotJobStatusEnumId.Cancelled;
}

export function isCostActionDisabledForLotDto(lot: ILotDto): boolean {
    return lot.jobStatus === LotJobStatusEnumId.Cancelled;
}

export function getCostActionDisabledText(): string {
    return 'This action is not allowed because the job has been cancelled';
}
